import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Footer from '../components/Footer/Footer';
import Pagetop from '../components/Pagetop/Pagetop';
import Eventdetails from '../components/Evendetails/Eventdetails';

class Eventdetailspage extends Component {
    constructor({match}){
        super();
        this.state={
            Eventdetailsid:match.params.Eventid,
            EventPassedName:match.params.eventName
        }
    }
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Event details" />
                <Pagetop title={this.state.EventPassedName}/>
                <Eventdetails id={this.state.Eventdetailsid} />
                <Footer/>
            </div>
        );
    }
}

export default Eventdetailspage;